export const SECONDS_PER_FIELD = 8;

export interface FieldState { required: boolean; filled: boolean }
export interface Progress { required: number; answered: number }

export function isFilled(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  if (value instanceof Date) return !Number.isNaN(value.getTime());
  if (typeof value === "string") return value.trim() !== "";
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

export function countProgress(fields: readonly FieldState[]): Progress {
  const required = fields.filter((field) => field.required);
  return { required: required.length, answered: required.filter((field) => field.filled).length };
}

export function sumProgress(parts: readonly Progress[]): Progress {
  return parts.reduce((sum, part) => ({ required: sum.required + part.required, answered: sum.answered + part.answered }), { required: 0, answered: 0 });
}

export function percent({ required, answered }: Progress): number {
  return required === 0 ? 100 : Math.round((answered / required) * 100);
}

export function estimateMinutes({ required, answered }: Progress): number {
  return Math.ceil(((required - answered) * SECONDS_PER_FIELD) / 60);
}
